import LogoGradientIcon from '../../icons/LogoGradientIcon'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectUser, setSession } from '../../reducers/users'
import { SessionState } from '../../types/UserTypes'
import { SegmentedControl } from '@radix-ui/themes'
import { selectActivity, setThreatHunterScreen } from '../../reducers/activity'
import { inPov } from '../../utils/session'

interface IDevicesHeaderProps {
  pageTitle: string
}

const ThreatHunterHeader = (props: IDevicesHeaderProps) => {
  const { pageTitle } = props
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { session, currentPage } = useSelector(selectUser)
  const { threatHunterScreen } = useSelector(selectActivity)

  useEffect(() => {
    const goToConfigured = localStorage.getItem('SSO_CONFIGURED_COOKIE')

    if (goToConfigured === 'true') {
      navigate('/settings')
    }
    if (window.location.search.includes('error=sso-unauthorized')) {
      navigate('/sso-error')
    }
  }, [])

  useEffect(() => {
    const storedSession = localStorage.getItem('session') as string

    if (currentPage === 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
    } else if (!session && storedSession === '{}' && currentPage !== 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
      navigate('/login')
    } else if (!session && storedSession !== '{}') {
      dispatch(setSession(JSON.parse(storedSession) as SessionState))
    }
  }, [session])

  useEffect(() => {
    if (import.meta.env.VITE_PRETTY_ENV !== 'Production' && import.meta.env.VITE_ON_PREM === 'false') {
      document.title = '[' + import.meta.env.VITE_PRETTY_ENV + '] ' + 'iVerify EDR Portal'
    }
  }, [])

  return (
    <>
      <div className="w-full absolute h-[74px] flex items-center px-6" style={{ top: inPov(session) ? '42px' : '0px' }}>
        <div className="flex items-center min-w-0 flex-1">
          <div className="h-[26px] w-[182px] shrink-0">
            <LogoGradientIcon height="26" width="71" />
          </div>
          <div className="ml-4 flex items-center overflow-hidden whitespace-nowrap text-ellipsis">
            <div className="font-semibold text-mainText text-xl">{pageTitle}</div>
          </div>
        </div>

        <div className="flex-1 flex justify-center min-w-0 max-w-[220px]">
          <SegmentedControl.Root
            value={threatHunterScreen}
            defaultValue="scans"
            className="h-[38px] bg-controllerBackground text-controllerText"
            onValueChange={(newValue: string) => dispatch(setThreatHunterScreen(newValue))}
          >
            <SegmentedControl.Item value="scans">Scans</SegmentedControl.Item>
            <SegmentedControl.Item value="settings">Settings</SegmentedControl.Item>
          </SegmentedControl.Root>
        </div>

        <div className="flex items-center justify-end flex-1" />
      </div>
    </>
  )
}

export default ThreatHunterHeader
